// extracted by mini-css-extract-plugin
export var pagination = "pagination-modules--pagination--3_jTN";
export var arrow = "pagination-modules--arrow--2x8r_";
export var slider = "pagination-modules--slider--2VSYu";